import { NavButton, SaveButton, SubmitButton, Form, MaterialIcon, ButtonWithIcon, ThemeColor, ThemeShade, InjectClientMetadata } from '@papa/components';
import { QueryClient } from '@tanstack/react-query';
import styled from 'styled-components';
import { schema } from '../../dataModel/yupSchema';
import {
    actionButtonStyling,
    backButtonStyling,
    CustomLayout,
    ErrorStyledIcon,
    ErrorStyledSectionHeader,
    Flex,
    StyledSeparator,
    StyledValidationErrorSummary,
} from '../../styles/FormElements';
import { Footer } from '../../Components/Footer';
import { WelcomeBanner } from '../../Components/WelcomeBanner';
import { ErrorItalicSubtext } from './FormHelpers';
import React from 'react';
import { pagesToQuestions } from '../../dataModel/pagesToQuestions';
import { NavBar } from '../../Components/HorizontalNav';
import { StudentAnswersKeys } from '../../dataModel/types';

const StyledActionButton = (Button: (props: any) => JSX.Element) => styled(Button)`
    ${actionButtonStyling}

    &${ButtonWithIcon.LoadingContainer} {
        background-color: transparent;
        margin-left: 0.4rem;
    }

    &${MaterialIcon.Root} {
        background-color: transparent;
    }
`;

export const StyledSave = StyledActionButton(SaveButton.Root);
export const StyledSubmit = StyledActionButton(SubmitButton.Root) as typeof SubmitButton.Root;

export const StyledPrevious = styled(NavButton.Root)`
    ${backButtonStyling}

    &${MaterialIcon.Root} {
        background-color: ${props => props.theme.neutral.faint};
        border: unset;
    }
`;

export const StyledBottomNav = styled.nav`
    display: flex;
    justify-content: flex-end;
    gap: 2rem;
    width: 100%;
`;

interface IFormLayoutProps {
    children: JSX.Element | JSX.Element[];
    queryClient: QueryClient;
}
export const FormLayout = (props: IFormLayoutProps) => {
    const { children, queryClient } = props;
    return (
        <>
            <InjectClientMetadata.Root<StudentAnswersKeys> otherProps={{ queryClient }} ComponentToRender={WelcomeBanner} />
            <InjectClientMetadata.Root<StudentAnswersKeys> ComponentToRender={NavBar} />
            <Form.Root>
                <CustomLayout>
                    <>
                        <StyledValidationErrorSummary
                            label={
                                <React.Fragment>
                                    <Flex>
                                        <ErrorStyledIcon iconName="warning" />
                                        <ErrorStyledSectionHeader>We're missing some information!</ErrorStyledSectionHeader>
                                    </Flex>
                                    <ErrorItalicSubtext>
                                        The links below show what needs to be corrected. Missing or incorrect items will be highlighted on each page; simply fix them and
                                        then resubmit your application.
                                    </ErrorItalicSubtext>
                                    <StyledSeparator orientation="horizontal" weight="regular" color={ThemeColor.error} shade={ThemeShade.dark} />
                                </React.Fragment>
                            }
                            schema={schema}
                            pagesToQuestions={pagesToQuestions}
                        />
                        {children}
                    </>
                </CustomLayout>
            </Form.Root>
            <InjectClientMetadata.Root<StudentAnswersKeys> ComponentToRender={Footer} />
        </>
    );
};
